var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"invite-login"},[_c('div',{staticClass:"title"},[_vm._v(_vm._s(_vm.$t('loginActivity.receiveReward')))]),_c('div',{staticClass:"content"},[_c('login-view',{attrs:{"btnLabel":_vm.$t('loginActivity.registerReceive'),"agreementBarStyle":{ paddingTop: '33px' },"btnBarStyle":{ padding: '17px 0 0' }}})],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }